import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../../components/Loader/Loader';
import { Col, FormGroup, Input,  Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { decryptData } from '../../../utils/helper';
import { failed } from '../../../utils/Tostify';
import { getApplicationType } from '../../../api/workflow';

const ImportApplicationType = ({setShowModal, getApplicationTypeStages}) => {
    let token = useSelector(state => state.userReducer.token);
    const [applicationList, setApplicationList] = useState([]);
    const [selectedApplication, setSelectedApplication] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();


    const getApplicationTypeList = async (page, limit, searchKey = "") => {
        let res;
        try {
            setIsLoading(true);
            // setSearch(searchKey);
            res = await getApplicationType({dispatch, token, page, limit, searchKey, dataLimit: "all"});
            const responseData = decryptData(res?.data);
            if (res?.status === "SUCCESS") {
                setApplicationList(responseData);
                setIsLoading(false);
            }else{
              setIsLoading(false);
              failed(res?.message);
            }
        } catch (error) {
            failed(res?.message);
            setIsLoading(false);
        }
    };

    const handleSelect = (e)=>{
        setSelectedApplication(e.target.value);
    };

    const handleImport =()=>{
        const stages = applicationList?.items.find((obj)=> obj?._id === selectedApplication)?.applicationStages;
        getApplicationTypeStages(stages);
        setShowModal(false);
    };

    useEffect(() => {
        getApplicationTypeList();
    }, []);


  return (
    <Fragment>
        <Modal isOpen={setShowModal} toggle={setShowModal} size="xl">
        <ModalHeader toggle={setShowModal} className="assign_blk">Import Application</ModalHeader>
            <ModalBody className="assign_modal_body">
            {isLoading ? <Loader /> : null}
                <Row className='m-0'>
                    <Col lg={12} className="location_block mb-3 p-0">
                    <FormGroup>
                        <Input type="select" value={selectedApplication} onChange={handleSelect}>
                            <option value="" disabled selected>--Select--</option>
                                {applicationList?.items?.length > 0 && applicationList.items?.map((option, index) => (
                                <option key={index} value={option._id}>{option.applicationTitle}</option>
                            ))}
                        </Input>
                    </FormGroup>
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <div className="d-flex justify-content-between">
                    <button className="save_btn" onClick={setShowModal}>Close</button>
                    <button className="save_btn" type="submit" onClick={handleImport}>Import</button>
                </div>
            </ModalFooter>
        </Modal>
  </Fragment>
  );
};

export default ImportApplicationType;
